import React, { useEffect, useRef, useState } from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  enhanced = false, 
  message = null, 
  type = 'default' // 'default', 'v2', 'dots', 'js'
}) => {
  const spinnerRef = useRef(null);
  const dotsRef = useRef([]);
  const [rotation, setRotation] = useState(0);
  const [dotsScale, setDotsScale] = useState([1, 0.5, 0]);

  // Animación JavaScript para spinner
  useEffect(() => {
    if (type === 'js' || type === 'default') {
      const interval = setInterval(() => {
        setRotation(prev => (prev + 6) % 360); // 6 grados cada 16ms = ~1 segundo por vuelta
      }, 16); // 60 FPS

      return () => clearInterval(interval);
    }
  }, [type]);

  // Animación JavaScript para dots
  useEffect(() => {
    if (type === 'dots') {
      let frame = 0;
      const interval = setInterval(() => {
        frame += 1;
        const phase1 = Math.sin(frame * 0.1) * 0.5 + 0.5;
        const phase2 = Math.sin(frame * 0.1 + Math.PI * 0.6) * 0.5 + 0.5;
        const phase3 = Math.sin(frame * 0.1 + Math.PI * 1.2) * 0.5 + 0.5;
        
        setDotsScale([
          0.3 + phase1 * 0.7,
          0.3 + phase2 * 0.7,
          0.3 + phase3 * 0.7
        ]);
      }, 50); // 20 FPS para dots

      return () => clearInterval(interval);
    }
  }, [type]);

  // Debug log removed

  const renderSpinner = () => {
    switch (type) {
      case 'js':
        return (
          <div 
            ref={spinnerRef}
            style={{
              width: '50px',
              height: '50px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #FF8C00',
              borderRight: '4px solid #8A2BE2',
              borderRadius: '50%',
              display: 'block',
              transform: `rotate(${rotation}deg)`,
              transition: 'none'
            }}
          ></div>
        );

      case 'dots':
        return (
          <div 
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center'
            }}
          >
            {dotsScale.map((scale, index) => (
              <div
                key={index}
                ref={el => dotsRef.current[index] = el}
                style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  background: '#FF8C00',
                  transform: `scale(${scale})`,
                  transition: 'none'
                }}
              ></div>
            ))}
          </div>
        );
      
      case 'v2':
        return (
          <div 
            style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'linear-gradient(45deg, transparent, transparent 35%, #FF8C00)',
              position: 'relative',
              transform: `rotate(${rotation}deg)`,
              transition: 'none'
            }}
          >
            <div style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              right: '5px',
              bottom: '5px',
              borderRadius: '50%',
              background: 'white'
            }}></div>
          </div>
        );
      
      default:
        return (
          <div 
            style={{
              width: '50px',
              height: '50px',
              border: enhanced ? 'none' : '4px solid #f3f3f3',
              borderTop: enhanced ? 'none' : '4px solid #FF8C00',
              borderRight: enhanced ? 'none' : '4px solid #8A2BE2',
              background: enhanced ? 'conic-gradient(from 0deg, #FF8C00, #8A2BE2, #FF8C00)' : 'transparent',
              borderRadius: '50%',
              display: 'block',
              transform: `rotate(${rotation}deg)`,
              transition: 'none',
              position: enhanced ? 'relative' : 'static'
            }}
          >
            {enhanced && (
              <div style={{
                position: 'absolute',
                top: '4px',
                left: '4px',
                right: '4px',
                bottom: '4px',
                background: 'white',
                borderRadius: '50%'
              }}></div>
            )}
          </div>
        );
    }
  };

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        {renderSpinner()}
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner; 